<template>
  <transition name="show">
    <header class="main-header" v-bind:class="{ contrasted: isPageContrasted, orange: isDecember }">
      <div class="container">
        <div class="left-container">
        <router-link to="/" class="logo" @click.native="closeModal">
          <img v-bind:class="{'logo-wide': isDecember}" v-if="isHomePage" :src="logoSrc" alt="logo" @click="smoothScroll" data-scroll-offset="0">
          <img v-bind:class="{'logo-wide': isDecember}" v-else :src="logoSrc" alt="logo">
          <div v-if="!isDecember" class="subtitle" v-bind:class="{'hidden' : route === 'home'}">
            <span><img src="/static/img/subtitle.svg" alt="logo"></span>
          </div>
          <div v-if="isBlogPage" class="text">blog</div>
        </router-link>
        <div class="logos">
          <img v-if="lang === 'pl'" src="/static/img/logo-header-pl.png" alt="FE" class="header-logos" />
          <img v-else src="/static/img/logo-header.png" alt="FE" class="header-logos" />
        </div>
        </div>
        <div class="size-icon" @click="sizeToggle" v-if="isAccessibilityVisible">
          <img v-if="!isPageContrasted" src="/static/img/zoom-in-icon.svg"/>
          <img v-if="isPageContrasted" src="/static/img/zoom-in-icon-yellow.svg"/>
        </div>
        <div class="eye-icon" @click="contrastToggle" v-if="isAccessibilityVisible">
          <img v-if="!isPageContrasted" src="/static/img/eye-icon.svg"/>
          <img v-if="isPageContrasted" src="/static/img/eye-icon-yellow.svg"/>
        </div>
        <div class="burger" v-bind:class="{close: isMenuOpen}" @click="menuToggle">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </header>
  </transition>
</template>

<script>
  import store from '../store/store';
  import smoothScroll from '../helpers/SmoothScroll';

  export default {
    name: 'main-header',
    computed: {
      isMenuOpen() {
        if (store.state.isMenuOpen) {
          store.commit('HIDE_CANVAS');
        } else if (this.isCanvasVisible) {
          store.commit('SHOW_CANVAS');
        }
        return store.state.isMenuOpen;
      },
      isBlogPage() {
        return store.state.isBlog;
      },
      canShowPARP() {
        return store.state.showPARP;
      },
      canShowPAIH() {
        return store.state.showPAIH;
      },
      lang() {
        return store.state.lang;
      },
      isHomePage() {
        return this.route === 'home';
      },
      route() {
        return this.$route.name
      },
      isAccessibilityVisible(){
        return store.state.isAccessibilityVisible
      },
      isPageContrasted(){
        return store.state.isPageContrasted
      },
      isCanvasVisible() {
        return this.route === 'home' || this.route === 'farms presentation' || this.route === 'airport presentation' || this.route === 'area presentation' || this.route === 'products'
      },
      smoothScroll: () => smoothScroll,
      isDecember() {
        return new Date().getMonth() === 11;
      },
      logoSrc() {
         return this.isDecember ? '/static/img/logo-xmas.png' : '/static/img/logo.png';
      }
    },
    methods: {
      menuToggle: function () {
        store.commit('TOGGLE_MENU');
      },
      contrastToggle: function () {
        store.commit('TOGGLE_PAGE_CONTRAST');
      },
      sizeToggle: function () {
        store.commit('TOGGLE_PAGE_FONT_SIZE');
      },
      closeModal: function () {
        store.commit('SET_MODAL', { visible: false, questionName: '' });
      }

    }
  }
</script>

<style scoped>
  .show-enter-active,
  .show-leave-active {
    transform: translate(0);
    transition: transform 0.5s 1s;
  }

  .show-enter,
  .show-leave-to {
    transform: translateY(-100%);
  }

  .eye-icon, .size-icon {
    cursor: pointer;
    position: absolute;
    top: 10px;
    right: 50px;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .size-icon{
    right: 90px;
  }

  .eye-icon img, .size-icon img {
    width: 24px;
  }


  .main-header.contrasted{
    background: #000;
  }
  .main-header.orange{
    background: #f9d7d0;
  }
  .contrasted .burger span{
    background: yellow;
  }
  .left-container{
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  }
  .logo-wide{
    width: 125px !important;
  }
  .logos{
    margin-right: 110px;
    flex: 1;
    margin-left: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }

  .logos img{
    max-height: 50px;
  }

   header.main-header .logo{
     margin: 0;
     display: flex;
   }
  header.main-header .subtitle{
    top: 45px;
  }

  @media (max-width: 675px){
    .logos{
      display: none;
    }
  }

  .logos img.header-logos{
    max-height:45px;
  }
 

</style>



// WEBPACK FOOTER //
// Header.vue?3bcb7276